import React, { Component } from 'react';
import EffectParameterSlider from './EffectParameterSlider.js';

class CompressorPartEffect extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        let className = "compressor-part";
        return (
            <div className={className}>
                 <EffectParameterSlider
                   effectNumber={this.props.effectNumber}
                   automation={this.props.automation}
                   name='Threshold'
                   sequencerEngine={this.props.sequencerEngine}
                   lfoEnabled={true}
                   selectedParameter={this.props.selectedParameter}
                   parameter={this.props.effect.thresholdParameter}
                   isParameter={true}
                   onParameterChanged={this.props.onParameterChanged}
                   step={0.1}
                   max={8}
                   min={-80}
                   />
                 <EffectParameterSlider
                   effectNumber={this.props.effectNumber}
                   automation={this.props.automation}
                   name='Ratio'
                   sequencerEngine={this.props.sequencerEngine}
                   lfoEnabled={true}
                   selectedParameter={this.props.selectedParameter}
                   parameter={this.props.effect.ratioParameter}
                   onParameterChanged={this.props.onParameterChanged}
                   isParameter={true}
                   step={0.1}
                   max={20}
                   min={1}
                   />
                 <EffectParameterSlider
                   effectNumber={this.props.effectNumber}
                   automation={this.props.automation}
                   name='Knee'
                   sequencerEngine={this.props.sequencerEngine}
                   lfoEnabled={true}
                   selectedParameter={this.props.selectedParameter}
                   parameter={this.props.effect.kneeParameter}
                   onParameterChanged={this.props.onParameterChanged}
                   isParameter={true}
                   step={0.1}
                   max={40}
                   min={0}
                   />
                 
                 <EffectParameterSlider
                   effectNumber={this.props.effectNumber}
                   automation={this.props.automation}
                   name='Attack'
                   sequencerEngine={this.props.sequencerEngine}
                   lfoEnabled={true}
                   selectedParameter={this.props.selectedParameter}
                   parameter={this.props.effect.attackParameter}
                   isParameter={true}
                   onParameterChanged={this.props.onParameterChanged}
                   step={0.001}
                   max={1}
                   min={0}
                   />
                 <EffectParameterSlider
                   effectNumber={this.props.effectNumber}
                   automation={this.props.automation}
                   name='Release'
                   selectedParameter={this.props.selectedParameter}
                   sequencerEngine={this.props.sequencerEngine}
                   lfoEnabled={true}
                   parameter={this.props.effect.releaseParameter}
                   isParameter={true}
                   onParameterChanged={this.props.onParameterChanged}
                   step={0.001}
                   max={1}
                   min={0.1}
                   />
            </div>
        );
    }
}

export default CompressorPartEffect;
